import { Modal } from "@gravity-ui/uikit";

import { ProductSamplesContent } from "../ProductSamplesContent";

interface ProductSamplesModalProps {
  open: boolean;
  onClose: () => void;
}

export const ProductSamplesModal = ({
  open,
  onClose,
}: ProductSamplesModalProps) => {
  return (
    <Modal open={open} onOpenChange={onClose} disableOutsideClick>
      <ProductSamplesContent isModal={true} onClose={onClose} />
    </Modal>
  );
};
